import CommonActionTypes from './common-types'

export const startChangeAccountLabel = data => ({
    type: CommonActionTypes.START_CHANGE_ACCOUNT_LABEL,
    payload: data,
})

export const successChangeAccountLabel = data => ({
    type: CommonActionTypes.SUCCESS_CHANGE_ACCOUNT_LABEL,
    payload: data,
})

export const failureChangeAccountLabel = data => ({
    type: CommonActionTypes.FAILURE_CHANGE_ACCOUNT_LABEL,
    payload: data,
})

export const finishChangeAccountLabel = data => ({
    type: CommonActionTypes.FINISH_CHANGE_ACCOUNT_LABEL,
    payload: data,
})
